/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { MapsService } from 'app/modules/maps/maps.service';
import _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {


  constructor(private _mapService: MapsService,
    private _localStorageService: LocalStorageService,
  ) { }

  getGridSortableColumns(): any {
    return { 'work_order_number@Job-#': 'work_order_number', 'work_order_due_date@Due-Date': 'due_date', 'work_order_scheduled_date@Scheduled-Date-&-Time': 'scheduled_start_time', 'route_name@Route-Name': 'route_name', 'departure@Departure': 'departure'};
  }

  getGridJobTypeMap(): any {
    return { 'ASSIGNED': 'assigned_jobs', 'UNSCHEDULED': 'unscheduled_jobs', 'OVERDUE': 'overdue_jobs', 'UNASSIGNED': 'unassigned_jobs' , 'ALL': 'all_jobs'};
  }



  //Save grid filter preferences in local storage
  saveGridPreference(prefrence: any, selectedDispatchTab: 'job' | 'route'): void {
    const gridPreference = this._localStorageService.getLocalStorage('dispatch_board_grid_preferences') || { job: {}, route: {} };
    gridPreference[selectedDispatchTab] = prefrence;
    this._localStorageService.setLocalStorage('dispatch_board_grid_preferences', gridPreference);
  }

  getGridPreference(selectedDispatchTab: 'job' | 'route'): void {
    const gridPreference = this._localStorageService.getLocalStorage('dispatch_board_grid_preferences') || {};
    return gridPreference[selectedDispatchTab];
  }

  constructQueryParams(params: {
    tab?: 'JOBS' | 'ROUTES' | 'PLANNING' | 'MAP';
    workOrderNumber?: string;
    jobUid?: string;
    teamUid?: string;
    userUid?: string;
    scheduledStartDate?: string; //Format: 'YYYY-MM-DD'
    timezone?: string;
  }): string {
    const queryParams = new URLSearchParams();

    if (params.tab && params.tab === 'ROUTES') {
      queryParams.set('tab', params.tab);
    }
    if (params.workOrderNumber) {
      queryParams.set('workOrderNumber', params.workOrderNumber);
    }
    if (params.jobUid) {
      queryParams.set('jobUid', params.jobUid);
    }
    if (params.teamUid) {
      queryParams.set('teamUid', params.teamUid);
    }
    if (params.userUid) {
      queryParams.set('userUid', params.userUid);
    }
    if (params.scheduledStartDate) {
      queryParams.set('scheduledStartDate', params.scheduledStartDate);
    }
    if (params.timezone) {
      queryParams.set('timezone', params.timezone);
    }
    return queryParams.toString();
  }

  extractQueryParams(url: string): { [key: string]: string } {
    const urlSearch = new URL(url).search;
    const queryParams = new URLSearchParams(urlSearch);
    const params: { [key: string]: string } = {};
    queryParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  }

}
